import React, { Component } from "react";
import firebase from "firebase";
import { StyleSheet, css } from "aphrodite";
import { STATUS } from "../../constants/constants";
import _ from "lodash";
import Spinner from "react-spinkit";

class SearchStudent extends Component {
  state = {
    isLoading: false,
    student: null,
    elements: null
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { query, universityFirebase } = this.props;

    this.setState({ isLoading: true }, async () => {
      let tmpElements = [];
      let start = (query.length === 10)? query: query+'-';
      let end = query+'~';

      try {
        let snapshot = await firebase
          .database()
          .ref(`${universityFirebase}/rawDataById`)
          .orderByKey()
          .startAt(start)
          .endAt(end)
          .limitToFirst(8)
          .once("value");
        let values = snapshot.val();
        let keys = (values && Object.keys(values)) || [];

        tmpElements = keys.map(key => {
          let facultyId = values[key].facultyId;
          values[key].key = key;
          values[key].facultyName = this.getFacultyNameById(facultyId);
          return values[key];
        });
      } catch (error) {
        console.error("Error", error);
      } finally {
        this.setState({ isLoading: false, elements: tmpElements });
      }
    });
  }

  //Completed
  getFacultyNameById = facultyId => {
    const { faculties } = this.props;
    if (facultyId === 0 || facultyId !== "all") {
      let faculty = faculties.filter(faculty => faculty.value.toString() === facultyId.toString());
      return faculty[0].label;
    }
  };

  renderButton = (status, studentId, email, downloadUri) => {
    const { handleApproveClick, handleRejectClick, handleDeleteClick, handleDownloadClick } = this.props;
    return (
      <div className={`btn-group`}>
        <button className={`btn btn-primary bold ${css(styles.btn120)} disabled`} style={{ opacity: 1 }}>
          {this.convertStatus(status)}
        </button>

        {(status === STATUS.NONE || status === STATUS.REJECTED) && (
          <button className={`btn btn-success`} onClick={() => handleApproveClick(status, studentId, email, this.loadData, downloadUri)}>
            <span className={"glyphicon glyphicon-ok"} />
          </button>
        )}

        {(status === STATUS.NONE || status === STATUS.APPROVED || status === STATUS.DOWNLOADED) && (
          <button className={`btn btn-danger`} onClick={() => handleRejectClick(studentId, email, this.loadData)}>
            <span className={"glyphicon glyphicon-remove"} />
          </button>
        )}

        {status === STATUS.REJECTED && (
          <button className={`btn btn-danger`} onClick={() => handleDeleteClick(studentId, downloadUri, this.loadData)}>
            <span className={"glyphicon glyphicon-trash"} />
          </button>
        )}

        {(status === STATUS.APPROVED || status === STATUS.DOWNLOADED) && (
          <button className={`btn btn-success`} onClick={() => handleDownloadClick(studentId, status, this.loadData)}>
            <span className={"glyphicon glyphicon-download"} />
          </button>
        )}

      </div>
    );
  };

  convertStatus = status => {
    let result;
    switch (status) {
      case STATUS.NONE:
        result = "New";
        break;
      case STATUS.APPROVED:
        result = "Approved";
        break;
      case STATUS.REJECTED:
        result = "Rejected";
        break;
      case STATUS.DOWNLOADED:
        result = "Downloaded";
        break;
      default:
        result = "New";
        break;
    }
    return result;
  };

  render() {
    const { closeModal, handleChangeRejectedReason } = this.props;
    const { elements, isLoading } = this.state;
    return (
      <div className={"container-fluid"}>
        {(elements && !isLoading) &&
          _.chunk(elements, 4).map((element, chunkIndex) => {
            return (
              <div key={chunkIndex}>
                <div className={"row"} key={chunkIndex}>
                  {element.map((item, index) => (
                    <div className={"col-md-3"} key={item.studentId}>
                      <div className={"row"}>
                        <div className={"col-md-12"}>
                          <div className={css(styles.imgContainer)}>
                            <img alt={"รูปภาพ"} className={css(styles.img)} src={item.downloadUri} />
                          </div>
                        </div>
                      </div>
                      <div className={"row"}>
                        <div className={"col-md-12 text-center"}>
                          <h4 className={"bold"}>{item.facultyName}</h4>
                        </div>
                        <div className={"col-md-12 text-center"}>
                          <h4 className={"bold"}>{item.studentId}</h4>
                        </div>
                      </div>
                      <div className={"row"}>
                        <div className={"col-md-12 text-center"}>{this.renderButton(item.status, item.studentId, item.emailAddress, item.downloadUri)}</div>
                      </div>
                      {item.status === STATUS.REJECTED && (
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h4 className={css(styles.txtReject)}>
                              {item.reason}
                              &nbsp;
                              <button type="button" className="btn btn-info" onClick={() => handleChangeRejectedReason(item.studentId, this.loadData)}>
                                <span className={"glyphicon glyphicon-repeat"} />
                              </button>
                            </h4>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col text-center"> <span>{item.dateTime}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <hr />
              </div>
            );
          })}
        {((!elements || elements.length === 0) && !isLoading) && (
          <div className={"row"}>
            <div className={"col-md-12 text-center"}>No Data</div>
          </div>
        )}
        {(isLoading) && (
          <div className={"row"}>
            <div className={"col-md-12 text-center"}>
              <Spinner name="three-bounce py-4" color="#337ab7" className={`text-center ${css(styles.loadingSym)}`} /></div>
          </div>
        )}
        <hr />
        <div className={"row"}>
          <div className={"col-md-12"}>
            <button className={"btn btn-danger btn-sm pull-right"} onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchStudent;

const styles = StyleSheet.create({
  txtReject: {
    fontWeight: "bold",
    color: "red"
  },
  imgContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: "10px",
    paddingRight: "10px",
    marginTop: "10px"
  },
  img: {
    width: "180px",
    height: "240px",
    objectFit: "cover",
    border: "1px solid lightgrey",
    marginBottom: "5px",
    borderRadius: "10px"
  },
  btnSpace: {
    marginRight: "4px",
    marginLeft: "4px"
  },
  btn120: {
    width: "120px"
  }
});



// WEBPACK FOOTER //
// /src/containers/Dashboard/SearchStudent.js